import { all, fork } from 'redux-saga/effects';
import { accountRootSaga } from './account/saga';
import { authRootSaga } from './auth/saga';
import { blacklistRootSaga } from './blacklist/saga';
import { compatibilityReportRootSaga } from './compatibilityReport/saga';
import { countersRootSaga } from './counters/saga';
import { favoritesRootSaga } from './favorites/saga';
import { mapsRootSaga } from './maps/saga';
import { matchesRootSaga } from './matches/saga';
import { memberChoicesRootSaga } from './memberchoices/saga';
import { membersRootSaga } from './members/saga';
import { messagesRootSaga } from './messages/saga';
import { paymentHistoriesRootSaga } from './paymentHistories/saga';
import { personalityReportRootSaga } from './personalityReport/saga';
import { photoRequestsRootSaga } from './photoRequests/saga';
import { photoRevealsRootSaga } from './photoReveals/saga';
import { picturesRootSaga } from './pictures/saga';
import { reflistsRootSaga } from './reflists/saga';
import { reportUserSaga } from './reportUser/saga';
import { scoresRootSaga } from './scores/saga';
import { specialOffersRootSaga } from './specialOffers/saga';
import { subscriptionsRootSaga } from './subscriptions/saga';
import { threadsRootSaga } from './threads/saga';
import { visitsRootSaga } from './visits/saga';

export const allCoreSagas = [
  fork(accountRootSaga),
  fork(authRootSaga),
  fork(blacklistRootSaga),
  fork(compatibilityReportRootSaga),
  fork(countersRootSaga),
  fork(favoritesRootSaga),
  fork(mapsRootSaga),
  fork(matchesRootSaga),
  fork(memberChoicesRootSaga),
  fork(membersRootSaga),
  fork(messagesRootSaga),
  fork(personalityReportRootSaga),
  fork(photoRequestsRootSaga),
  fork(photoRevealsRootSaga),
  fork(picturesRootSaga),
  fork(reflistsRootSaga),
  fork(scoresRootSaga),
  fork(subscriptionsRootSaga),
  fork(threadsRootSaga),
  fork(visitsRootSaga),
  fork(specialOffersRootSaga),
  fork(paymentHistoriesRootSaga),
  fork(reportUserSaga),
];

export function* rootSaga() {
  yield all(allCoreSagas);
}
